import script from "./ReportsManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsManager.vue?vue&type=script&setup=true&lang=js"

import "./ReportsManager.vue?vue&type=style&index=0&id=20d79a26&lang=css"

const __exports__ = script;

export default __exports__